function getNumericUserId(worker) {
    const value = String(worker?.userId ?? '').trim();
    if (!value) return null;

    const userId = Number(value);
    return Number.isFinite(userId) ? userId : null;
}

export function sortSchedulerWorkersByUserId(workers = []) {
    return workers
        .map((worker, originalIndex) => ({
            worker,
            originalIndex,
            userId: getNumericUserId(worker),
        }))
        .sort((left, right) => {
            if (left.userId == null && right.userId == null) {
                return left.originalIndex - right.originalIndex;
            }
            if (left.userId == null) return 1;
            if (right.userId == null) return -1;

            return left.userId - right.userId || left.originalIndex - right.originalIndex;
        })
        .map(({worker}) => worker);
}
